<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <g v-if="weight === 'THIN'" mask="url(#mask-thin)">
            <path
                d="M9.55006 17.3078L4.58081 12.3386L5.29431 11.6251L9.55006 15.8808L18.7058 6.7251L19.4193 7.4386L9.55006 17.3078Z"
                fill="currentColor"
            />
            <mask
                id="mask-thin"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
        </g>

        <g v-else-if="weight === 'REGULAR'" mask="url(#mask-regular)">
            <path
                d="M9.55008 17.6538L4.21558 12.3193L5.28458 11.2501L9.55008 15.5156L18.7156 6.3501L19.7846 7.41935L9.55008 17.6538Z"
                fill="currentColor"
            />
            <mask
                id="mask-regular"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
        </g>

        <g v-else mask="url(#mask-fill)">
            <path
                d="M9.5501 18.0001L3.8501 12.3001L5.2751 10.8751L9.5501 15.1501L18.7251 5.9751L20.1501 7.4001L9.5501 18.0001Z"
                fill="currentColor"
            />
            <mask
                id="mask-fill"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
            >
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'check-icon',
    props: {
        width: {
            type: [String, Number],
            default: 24,
        },
        height: {
            type: [String, Number],
            default: 24,
        },
        color: {
            type: String,
            default: 'text-black',
        },
        weight: {
            type: String,
            default: 'THIN',
            validator: (val) => ['THIN', 'REGULAR', 'FILL'].includes(val),
        },
    },
};
</script>
